import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BillingManagementService } from '../../../service/billing-management.service';
import { ConfigurationManagementService } from '../../../service/configuration-management.service';
import { LanguageManagementService } from '../../../service/language-management.service';
import { BusinessEnabledOption, ExcelSalesReportTitle, ExcelSalesReportTitleDetail, ExcelSalesReportTitleDetailWithProfit, ExcelSalesReportTitleWithProfit, FocusInputType, GeneralConfigType, InteractionType, LocalService, PageKey, PaymentType, RelationShipRole, SalesReportBy, Wrapper20Initialization } from '../../../service/local.service';
import { LocalDatePipe } from '../../pipes/local-date.pipe';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { GraphComponent } from 'src/app/shared/graph/graph.component';

@Component({
  selector: 'app-sales-report',
  templateUrl: './sales-report.component.html',
  styleUrls: ['./sales-report.component.scss']
})
export class SalesReportComponent implements OnInit {
  SalesReportBy = SalesReportBy; PaymentType = PaymentType;
  lstSectionConfigKeys: string[] = ["sales_report"];
  selectedUserId: string = ''; relationShipType: InteractionType = InteractionType.Business; relationShipRole: RelationShipRole = RelationShipRole.EndCustomer;
  businessId = ''; interactionType = 0; source: Wrapper20Initialization; ctryCode = ''; userId = ''; IsPrint = false;
  fileName = ''; printContent = ''; reportTime: Date; totalAmount = 0; reportRange = ''; maxBodyHeight = 0;
  selectedReportBy: string = SalesReportBy.Receipt.toString(); selectedPaymentBy: string = PaymentType.None.toString(); searchKey = '';
  htmlId: string = ''; elementIds: any; reportTypeWidth = 100; totalPrice = 0; totalPriceWithTax = 0; totalPurchasePriceWithTax = 0; profit = 0; totalPaidAmount = 0; totalRemainingAmount = 0;
  isExcluded: boolean = false; isExcludedEnabled: boolean = false; isBusinessHasPurchaseEntry = false;
  RelationShipRole = RelationShipRole; selectedProductLabel = '';
  isCompactSalesReport = false; selectedPaymentMode = PaymentType.MultiPayment.toString(); isAmountPaid = true; selectedBillId = '';
  selectedTotalAmount = 0; isOpenPaymentModes = false;

  constructor(public localService: LocalService, private cdr: ChangeDetectorRef, private languageManagementService: LanguageManagementService, private route: ActivatedRoute, public billingManagementService: BillingManagementService, private router: Router, private configurationManagementService: ConfigurationManagementService, private modalService: NgbModal) {
    this.htmlId = this.localService.getRandomString(5);
    this.elementIds = {
      report_type_div: 'report_type_div_' + this.htmlId,
      lbl_title: 'lbl_title_' + this.htmlId,
      txt_search_key: 'txt_search_key_' + this.htmlId,
      payment_type_div: 'payment_type_div_' + this.htmlId,
    };
  }

  ngOnInit(): void {
    this.languageManagementService.ensureLanguageSectionKeys(this.lstSectionConfigKeys);
    this.route.params.subscribe(routeParams => {
      this.interactionType = routeParams.interactionType;
      this.ctryCode = routeParams.ctryCode;
      this.userId = routeParams.userId;
      this.businessId = routeParams.businessId;
      this.selectedUserId = '';
      this.configurationManagementService.ensurePageActions(PageKey.SalesReport, this.businessId);
      this.fileName = this.ctryCode + '_' + this.businessId;
      if (this.interactionType != InteractionType.User && (this.businessId == '' || this.businessId == '0')) {
        this.localService.redirectToSeller();
      } else {
        this.localService.saveUrl();
        this.localService.setBasicParams(routeParams.ctryCode, routeParams.userId, routeParams.interactionType, routeParams.businessId);
        this.onLoad();
      }
      this.onCheckDeviceSettings();
    });
  }

  ngAfterViewChecked() {
    this.maxBodyHeight = this.localService.onGetCustomBodyHeight() - 25;
    this.cdr.detectChanges();
  }

  isProcessing = false;
  onLoad(isForceClear = false) {
    if (this.localService.isUserHasBusinessRole(this.businessId, RelationShipRole.Admin)) {
      this.isExcludedEnabled = this.localService.isBusinessOptionEnabled(this.businessId, BusinessEnabledOption.IsExcludedPricingEnabled);
      this.isBusinessHasPurchaseEntry = this.localService.isBusinessHasPurchaseEntry(this.businessId);

      if (isForceClear && this.source && this.source.content)
        this.source.content.items = undefined;
      if (!this.source) {
        this.billingManagementService.getSalesReportInitialization(this.businessId).subscribe(result => {
          this.source = result;
          this.setData();
        });
      } else {
        if (!this.isProcessing) {
          this.isProcessing = true;
          this.billingManagementService.getSalesReport(this.businessId, this.source.content.paging, parseInt(this.selectedReportBy), parseInt(this.selectedPaymentBy), parseInt(this.selectedReportBy) == SalesReportBy.Receipt, this.searchKey, this.isExcluded, this.selectedUserId, this.selectedProductLabel).subscribe(result => {
            this.source.content = result;
            this.setData();
            this.isProcessing = false;
          });
        }
      }
    }
  }

  onCheckDeviceSettings() {
    this.isCompactSalesReport = this.localService.onGetCurrentDeviceSettingsOfBusiness()?.IsCompactViewInSalesReport;
  }

  onPagingRefresh(index: number) {
    switch (index) {
      case 1: {
        this.source.content.paging.currentPage = this.source.content.paging.currentPage - 1;
      } break;
      case 2: {
        this.source.content.paging.currentPage = this.source.content.paging.currentPage + 1;
      } break;
    }
    this.onLoad();
  }

  onSelectSalesReportBy() {
    this.searchKey = '';
    this.onLoad(true);
  }

  onRemovePaymentBy() {
    this.selectedPaymentBy = PaymentType.None.toString();
    this.onSelectSalesReportBy();
  }

  onSetReportTypeWidth() {
    setTimeout(() => {
      const element = document.getElementById(this.elementIds.report_type_div);
      if (element) {
        this.reportTypeWidth = element.clientWidth;
      }

      if (this.selectedReportBy != '1') {
        this.localService.onFocusNextInput(this.elementIds.txt_search_key, FocusInputType.TextBox);
      }
    }, 200);
  }

  onLanguageChanged() {
    this.configurationManagementService.getConfigurationsToDisplay(GeneralConfigType.PaymentType).subscribe(result => {
      this.source.options = result;
    });
  }

  onRoute(key: string) {
    if (key && key.trim().length > 0 && key != '-') {
      this.router.navigate(['/billing', this.ctryCode, this.userId, InteractionType.Business, this.businessId, key]);
    }
  }

  onPrint() {
    this.billingManagementService.getReportData(this.businessId, this.source.content.paging, parseInt(this.selectedReportBy), parseInt(this.selectedPaymentBy), parseInt(this.selectedReportBy) == SalesReportBy.Receipt, this.searchKey, this.isExcluded, this.selectedUserId, this.selectedProductLabel).subscribe(resultSource => {
      let reportTime = this.reportTime.toLocaleDateString() + ", " + this.reportTime.toLocaleTimeString();
      let createdPhonePrefix = this.localService.getContactPrefixByCountryCode(this.localService.selected.countryCode);
      let loggedMember = this.localService.getLoggedMemberName();
      let businessName = this.localService.getBusinessName(this.businessId);
      var totalPrice = this.source.content.paging.sumVals.length > 0 ? this.source.content.paging.sumVals[0] : 0;
      var totalPriceWithTax = this.source.content.paging.sumVals.length > 1 ? this.source.content.paging.sumVals[1] : 0;
      var totalAmount = this.source.content.paging.sumVals.length > 2 ? this.source.content.paging.sumVals[2] : 0;

      const localDatePipe = new LocalDatePipe();
      this.configurationManagementService.getGlobalConfigurationByCode('receipt_style', this.businessId).subscribe(result => {
        this.printContent = '<style>' + result.value;
        this.printContent += 'thead td{text-align:center;font-weight:bold;} td{padding:7px;} .normal{font-weight:normal;} .left{text-align:left;}</style>';
        this.printContent += '<table style="width:95%;margin:20px;"><thead class="' + this.localService.selectedLanguageCode + '">';

        this.printContent += '<tr><td colspan="4"><span class="' + businessName.key + '">' + businessName.value + '</span></td></tr>';

        this.printContent += '<tr><td colspan="2" class="left">' + this.localService.languageContent.sales_report.report_time + '<span class="en normal">&nbsp;:&nbsp;' + reportTime + '</span></td><td colspan="2" class="left">' + this.localService.languageContent.sales_report.grand_total + '<span class="en normal">&nbsp;:&nbsp;' + (parseInt(this.selectedReportBy) == SalesReportBy.Receipt ? totalAmount : totalPriceWithTax).toFixed(2) + '</span></td></tr>';

        var reportRange = this.reportRange = localDatePipe.getFromString(this.source.content.paging.dateFromS) + " : " + localDatePipe.getFromString(this.source.content.paging.dateToS);

        this.printContent += '<tr><td colspan="2" class="left">' + this.localService.languageContent.sales_report.report_range + '<span class="en normal">&nbsp;:&nbsp;' + reportRange + '</span></td><td colspan="2" class="left">' + this.localService.languageContent.sales_report.report_by + '<span class="en normal">&nbsp;:&nbsp;+' + createdPhonePrefix + ' ' + this.localService.loggedMember.loggedMember.content.v9 + '&nbsp;(</span><span class="normal ' + loggedMember.key + '">' + loggedMember.value + '</span><span class="en normal">)</span></td></tr>';

        if (parseInt(this.selectedReportBy) == SalesReportBy.Receipt) {
          this.printContent += '<tr><td style="width:25%">' + this.localService.languageContent.sales_report.paid_on + '</td><td style="width:20%">' + this.localService.languageContent.sales_report.bill_nbr + '</td><td style="width:20%">' + this.localService.languageContent.sales_report.amount + '</td><td style="width:35%">' + this.localService.languageContent.sales_report.payment_mode + '</td></tr>';
        } else {
          const title = this.localService.getText(this.source.reportBy, this.selectedReportBy);

          this.printContent += '<tr><td style="width:25%">' + title + '</td><td style="width:20%">' + this.localService.languageContent.sales_report.qty + '</td><td style="width:20%">' + this.localService.languageContent.sales_report.total_price + '</td><td style="width:35%">' + this.localService.languageContent.sales_report.total_price_tax + '</td></tr>';
        }

        this.printContent += '</thead><tbody>';
        if (parseInt(this.selectedReportBy) == SalesReportBy.Receipt) {
          resultSource.items.forEach(item => {
            this.printContent += '<tr><td class="border-top">' + localDatePipe.transform(item.v1) + '</td><td class="border-top">' + item.v2 + '</td><td style="text-align:right" class="border-top">' + Math.round(parseFloat(item.v5)).toFixed(2) + '</td><td class="border-top ' + this.localService.selectedLanguageCode + '">' + this.localService.getText(this.source.options, item.v4) + '</td></tr>';
          });
        } else {
          resultSource.items.forEach(item => {
            this.printContent += '<tr><td class="border-top">' + item.v8 + '</td><td class="border-top" style="text-align:right">' + item.v6 + '</td><td style="text-align:right" class="border-top">' + parseFloat(item.v5).toFixed(2) + '</td><td class="border-top" style="text-align:right">' + parseFloat(item.v9).toFixed(2) + '</td></tr>';
          });
        }
        this.printContent += '<tfoot><tr><td colspan="4" class="en" style="color:grey;position: fixed;bottom: 0;right:0">Powered by Bill_PnixSoft</td></tr></tfoot></tbody></table>';

        this.IsPrint = true;
      });
    });

  }

  setData() {
    this.source.content.items.filter(x => x.v16 && x.v16.length > 0).forEach(item => {
      item.v16 = this.localService.languageContent.sales_report[item.v16];
    });

    this.onSetReportTypeWidth();
    const localDatePipe = new LocalDatePipe();
    this.reportTime = localDatePipe.getDeviceDate();
    this.totalPrice = this.source.content.paging.sumVals.length > 0 ? this.source.content.paging.sumVals[0] : 0;
    this.totalPriceWithTax = this.source.content.paging.sumVals.length > 1 ? this.source.content.paging.sumVals[1] : 0;
    this.totalAmount = this.source.content.paging.sumVals.length > 2 ? this.source.content.paging.sumVals[2] : 0;
    this.totalPurchasePriceWithTax = this.source.content.paging.sumVals.length > 3 ? this.source.content.paging.sumVals[3] : 0;
    this.totalPaidAmount = this.source.content.paging.sumVals.length > 4 ? this.source.content.paging.sumVals[4] : 0;
    this.totalRemainingAmount = this.source.content.paging.sumVals.length > 5 ? this.source.content.paging.sumVals[5] : 0;
    this.profit = this.totalPriceWithTax - this.totalPurchasePriceWithTax;
    this.reportRange = localDatePipe.getFromString(this.source.content.paging.dateFromS) + " : " + localDatePipe.getFromString(this.source.content.paging.dateToS);
  }

  onPrinted() {
    this.IsPrint = false;
  }

  onDownload() {
    this.billingManagementService.getExcelData(this.businessId, this.source.content.paging, parseInt(this.selectedReportBy), parseInt(this.selectedPaymentBy), parseInt(this.selectedReportBy) == SalesReportBy.Receipt, this.searchKey, this.isExcluded, this.selectedUserId, this.selectedProductLabel).subscribe(result => {
      this.localService.onDownloadFile(result, 'SalesReport_' + this.localService.getDeviceDateWithFormat('DD-MMM-YYYY'));
    });
  }

  onUserUpdated(e) {
    this.selectedUserId = e;
    this.onLoad();
  }

  onShowGraph() {
    this.billingManagementService.getExcelData(this.businessId, this.source.content.paging, parseInt(this.selectedReportBy), parseInt(this.selectedPaymentBy), parseInt(this.selectedReportBy) == SalesReportBy.Receipt, this.searchKey, this.isExcluded, this.selectedUserId, this.selectedProductLabel, true).subscribe(result => {
      if (result.length > 0) {
        if (result[0].rows.length > 0) {
          switch (result[0].type) {
            case 1:
            case 3: {
              const graphDataByAmount = this.groupByTimeAndSumAmount(result[0].rows as ExcelSalesReportTitleDetail[]);
              const graphDataByQuantity = this.groupByTimeAndSumQuantity(result[0].rows as ExcelSalesReportTitleDetail[]);
              const graphDataByProfit = this.isBusinessHasPurchaseEntry ? this.groupByTimeAndSumProfit(result[0].rows as ExcelSalesReportTitleDetailWithProfit[]) : undefined;
              const modalRef = this.modalService.open(GraphComponent, { size: 'xl' });
              modalRef.componentInstance.graphDataByAmount = graphDataByAmount;
              modalRef.componentInstance.graphDataByQuantity = graphDataByQuantity;
              modalRef.componentInstance.graphDataByProfit = graphDataByProfit;
              if (this.selectedReportBy == '1') {
                modalRef.componentInstance.isShowQuantity = false;
              }
              if (graphDataByProfit) {
                modalRef.componentInstance.isShowProfit = true;
              }
            } break;
            case 2: {
              const graphDataByAmount = this.groupByTitleAndSumAmount(result[0].rows as ExcelSalesReportTitle[]);
              const graphDataByQuantity = this.groupByTitleAndSumQuantity(result[0].rows as ExcelSalesReportTitleDetail[]);
              const graphDataByProfit = this.isBusinessHasPurchaseEntry ? this.groupByTitleAndSumProfit(result[0].rows as ExcelSalesReportTitleDetailWithProfit[]) : undefined;
              const modalRef = this.modalService.open(GraphComponent, { size: 'xl' });
              modalRef.componentInstance.graphDataByAmount = graphDataByAmount.sort((a, b) => a.x.localeCompare(b.x));
              modalRef.componentInstance.graphDataByQuantity = graphDataByQuantity.sort((a, b) => a.x.localeCompare(b.x));
              modalRef.componentInstance.graphDataByProfit = graphDataByProfit.sort((a, b) => a.x.localeCompare(b.x));
              if (graphDataByProfit) {
                modalRef.componentInstance.isShowProfit = true;
              }
            } break;
          }
        }
      }
    });
  }

  onAction(index: number, key?: string) {
    switch (index) {
      case 1: {
        const item = this.source.content.items.find(x => x.key == key);
        if (item) {
          this.selectedBillId = key;
          this.isAmountPaid = true;
          this.selectedPaymentMode = PaymentType.MultiPayment.toString();
          this.selectedTotalAmount = parseFloat(item.v5);
          this.isOpenPaymentModes = true;
        }
      } break;
      case 2: {
        const item = this.source.content.items.find(x => x.key == key);
        if (item) {
          this.selectedBillId = key;
          this.isAmountPaid = false;
          this.selectedPaymentMode = PaymentType.Upi.toString();
          this.selectedTotalAmount = parseFloat(item.v13);
          this.isOpenPaymentModes = true;
        }
      } break;
    }
  }

  onGetSum(value1: string, value2: string): number {
    return parseFloat(value1) + parseFloat(value2);
  }

  groupByTitleAndSumAmount(data: ExcelSalesReportTitle[]) {
    const grouped = data.reduce((acc, item) => {
      const { Title, TotalWithTax } = item;
      if (!acc[Title]) {
        acc[Title] = 0;
      }
      acc[Title] += TotalWithTax;
      return acc;
    }, {} as { [key: string]: number });

    // Convert the grouped object to an array format
    return Object.keys(grouped).map(Title => ({
      x: Title,
      y: grouped[Title]
    }));
  }

  groupByTimeAndSumAmount(data: ExcelSalesReportTitleDetail[]) {
    const grouped = data.reduce((acc, item) => {
      const { PaidOn, TotalWithTax } = item;
      if (!acc[PaidOn]) {
        acc[PaidOn] = 0;
      }
      acc[PaidOn] += TotalWithTax;
      return acc;
    }, {} as { [key: string]: number });

    // Convert the grouped object to an array format
    return Object.keys(grouped).map(PaidOn => ({
      x: PaidOn,
      y: grouped[PaidOn]
    }));
  }

  groupByTitleAndSumQuantity(data: ExcelSalesReportTitle[]) {
    const grouped = data.reduce((acc, item) => {
      const { Title, Quantity } = item;
      if (!acc[Title]) {
        acc[Title] = 0;
      }
      acc[Title] += Quantity;
      return acc;
    }, {} as { [key: string]: number });

    // Convert the grouped object to an array format
    return Object.keys(grouped).map(Title => ({
      x: Title,
      y: grouped[Title]
    }));
  }

  groupByTitleAndSumProfit(data: ExcelSalesReportTitleWithProfit[]) {
    const grouped = data.reduce((acc, item) => {
      const { Title, Profit } = item;
      if (!acc[Title]) {
        acc[Title] = 0;
      }
      acc[Title] += Profit;
      return acc;
    }, {} as { [key: string]: number });

    // Convert the grouped object to an array format
    return Object.keys(grouped).map(Title => ({
      x: Title,
      y: grouped[Title]
    }));
  }

  groupByTimeAndSumQuantity(data: ExcelSalesReportTitleDetail[]) {
    const grouped = data.reduce((acc, item) => {
      const { PaidOn, Quantity } = item;
      if (!acc[PaidOn]) {
        acc[PaidOn] = 0;
      }
      acc[PaidOn] += Quantity;
      return acc;
    }, {} as { [key: string]: number });

    // Convert the grouped object to an array format
    return Object.keys(grouped).map(PaidOn => ({
      x: PaidOn,
      y: grouped[PaidOn]
    }));
  }

  groupByTimeAndSumProfit(data: ExcelSalesReportTitleDetailWithProfit[]) {
    const grouped = data.reduce((acc, item) => {
      const { PaidOn, Profit } = item;
      if (!acc[PaidOn]) {
        acc[PaidOn] = 0;
      }
      acc[PaidOn] += Profit;
      return acc;
    }, {} as { [key: string]: number });

    // Convert the grouped object to an array format
    return Object.keys(grouped).map(PaidOn => ({
      x: PaidOn,
      y: grouped[PaidOn]
    }));
  }
}


